<template>
  <vx-card title="Skills Editor">
    <vs-input class="inputx tree-search-input float-left mr-2" placeholder="Search..." v-model.lazy="searchword" />
    <vs-button color="primary" type="filled" @click="search" class="mb-3">Search</vs-button>
    <v-tree ref='tree' v-on:node-expand="expandNode" search-nested="true" :canDeleteRoot="false" 
      :data='treeData' :halfcheck='false' :multiple="false"/>
    <CategoryEditorScreen 
      :editCategoryId="editCategoryId" 
      :isEditing="categoryEdit"
      v-on:update:isEditing="categoryActiveUpdated">
    </CategoryEditorScreen>
    <SkillEditorScreen 
      :skillId="editSkillId" 
      :isEditing="skillEdit" 
      v-on:update:isEditing="skillActiveUpdated" 
      :parentCategoryNode="parentCategoryNode" 
      >
    </SkillEditorScreen>
  </vx-card>
</template>
 
<script>
import { VTree, VSelectTree}  from 'vue-tree-halower'
import SkillsService from '@/skills/skillsService.js'
import CategoryEditorScreen from '@/views/components/extra-components/categoryeditor/CategoryEditorScreen.vue'
import SkillEditorScreen from '@/views/components/extra-components/skilleditor/SkillEditorScreen.vue'

export default {
  data() {
    return {
      searchword: '',
      treeData: [],
      editCategoryId: -1,
      editSkillId: -1,
      categoryEdit: false,
      skillEdit: false,
      parentCategoryNode: null
    }
  },
  mounted(){
    var temp = [];
    this.treeData = [{
      title: "Tracks",
      itemId: -1,
      nodeType: 'Root',
      children: temp 
    }];
  },
  methods: {
    search () {
      this.$refs.tree.searchNodes(this.searchword);
    },
    saveNode(node, parent, index){ 
      var vue = this;
      var nodeParentId = parent != null ? parent.itemId : -1;
      var nodeId = node.itemId;
      if (node.nodeType == 'Category'){
          SkillsService.saveCategory({
            DirectMapping: { 
              Id: nodeId,  
              CategoryTitle: node.titleBk,
              CategoryOrder: index
            }, 
            Relations: {
              ParentId: nodeParentId
            }
          }).then(function(response){
            node.itemId = response.data.Id;

            vue.$vs.notify({
              title: 'Success',
              text: 'Category ' + response.data.CategoryTitle + ' was saved successfully.',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
          });
      }
      else {
          SkillsService.saveSkill({
            DirectMapping: { 
              Id: nodeId,  
              SkillName: node.titleBk
            }, 
            Relations: {
              ParentId: nodeParentId
            }
          }).then(function(response){
            node.itemId = response.data.Id;
            vue.$vs.notify({
              title: 'Success',
              text: 'Skill ' + response.data.SkillName + ' was saved successfully.',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
          });
      }
    },
    skillActiveUpdated(val){
      this.skillEdit = val.isEdit;

        // this.skillEdit = val;
    },
    categoryActiveUpdated(val){
        this.skillEdit = val.isEdit;
    },
    expandNode(node){
      var forParent = node.itemId;

      SkillsService.getCategories(forParent)
        .then(function(response){

          var temp = [];

          if (node.itemId == -1){
            if (response.data && response.data.length > 0){
              for (var i = 0; i < response.data.length; i++){
                var currentCategory = response.data[i];
                temp.push({
                    title: currentCategory.CategoryTitle,
                    itemId: currentCategory.Id,
                    nodeType: 'Category',
                    children: [{
                      title: '',
                      itemId: -1
                    }]
                })
              }
            }
          }
          else {
          if (response.data && 
              response.data.length > 0 && 
              response.data[0].Children && 
              response.data[0].Children.length)
          for (var j = 0; j < response.data[0].Children.length; j++){
            var currentChild = response.data[0].Children[j];
                  temp.push({
                    title: currentChild.CategoryTitle,
                    itemId: currentChild.Id,
                    nodeType: 'Category',
                    children: [{
                      title: '',
                      itemId: -1
                    }]
                  });
            }

            if (response.data[0] && response.data[0].Skills && response.data[0].Skills.length > 0){
                for(var i = 0; i < response.data[0].Skills.length; i++){
                  var currentSkill = response.data[0].Skills[i];
                  temp.push({
                    title: currentSkill.SkillName,
                    itemId: currentSkill.Id,
                    nodeType: 'Skill'
                  })
                }
              }
          }

          node.children = temp;
        });
    },
    editFullScreen(node, parent){
      var itemType = node.nodeType;
      if (itemType == 'Category'){
        this.skillEdit = false;
        this.categoryEdit = true;
        this.editCategoryId = node.itemId;
      }
      else if (itemType == 'Skill'){
        this.skillEdit = true;
        this.categoryEdit = false;
        this.editSkillId = node.itemId;
        this.parentCategoryNode = parent;
      }
    },
    deleteNode(node, parent, index, tree){
      var id = node.itemId;
      var vue = this;
      if (id && id > 0 && confirm("Are you sure?")){
          if (node.nodeType == 'Category'){
            SkillsService.deleteCategory(id).then(function(){
              var title = node.title;
              tree.tree.delNode(node, parent, index);
              vue.$vs.notify({
                  title: 'Success',
                  text: 'Category ' + title + ' was deleted successfully.',
                  color: 'success',
                  iconPack: 'feather',
                  icon: 'icon-check'
              })
            });
          }
          else{
            SkillsService.deleteSkill(id).then(function(){
              var title = node.title;
              tree.tree.delNode(node, parent, index);
              vue.$vs.notify({
                  title: 'Success',
                  text: 'Skill ' + title + ' was deleted successfully.',
                  color: 'success',
                  iconPack: 'feather',
                  icon: 'icon-check'
              })
            });
          }
      }
      else if (!id || id <= 0) {
        tree.tree.delNode(node, parent, index);
      }
    },
    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      let isCategory = node.nodeType === 'Category';

      let saveBtnClasses = "btn-save text-success border-none cursor-pointer px-2 py-1 rounded ";
      
      if (node.searched) titleClass += ' node-searched'
      if (!isCategory && !node.nodeType == 'Root') saveBtnClasses += 'hidden';

      return <span>        
         <span ref="nodeText" class={titleClass} domPropsInnerHTML={node.title} contenteditable="true" 
         onInput={() => { node.titleBk = this.$refs.nodeText.innerText }} 
         onClick={() => { this.$refs.tree.nodeSelected(node) }}
         >
      </span>
      <button class="btn-save text-success border-none cursor-pointer px-2 py-1 rounded" onClick={() => 
          this.saveNode(node, parent, index, this.$refs)}>
          <vs-icon style="max-width:1rem;" icon="save_outline"></vs-icon>
      </button>
      &nbsp;
      <button class="btn-delete text-danger border-none cursor-pointer px-2 py-1 rounded" tooltip="Delete" onClick={() => 
        this.deleteNode(node, parent, index, this.$refs)}>
        <vs-icon icon="delete_outline"></vs-icon>
      </button>
      &nbsp;
      <button class={saveBtnClasses} onClick={() => 
        this.$refs.tree.addNode(node, {title: 'Category Title', nodeType: 'Category'})}>
          <vs-icon icon="create_new_folder"></vs-icon>
        </button>
      &nbsp;
      <button class={saveBtnClasses} onClick={() => 
        this.$refs.tree.addNode(node, {title: 'Skill Title', nodeType: 'Skill'})}>
          <vs-icon icon="person_add"></vs-icon>
      </button>
      &nbsp;
      <button class="btn-warning text-warning border-none cursor-pointer px-2 py-1 rounded" onClick={() => 
        this.editFullScreen(node, parent, index, this.$refs)}>
          <vs-icon icon="fullscreen"></vs-icon>
      </button>
      &nbsp;
      </span>
    }
  },
  components: {
    VTree,
    VSelectTree,
    CategoryEditorScreen,
    SkillEditorScreen
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/extraComponents/tree.scss";

button.btn-async{
  background: rgba(var(--vs-warning),0.15);
}

button.btn-delete{
  background: rgba(var(--vs-danger),0.15);
}
</style>